import { useNavigate, useParams } from "react-router-dom";
import { Box } from "@mui/material";
import ExtendContract from "./ExtendContract";
export const ShowContract = () => {
  const { id } = useParams();

  const navigate = useNavigate();

  return (
    <Box className="pt-0 md:pt-12 w-full h-full flex flex-col">
      <ExtendContract
        row={{ id, onUpdate: () => {}, onDelete: () => {} }}
        onDelete={() => navigate("/contracts")}
      />
    </Box>
  );
};
